export const REQUIREMENTS = ["VIDEO EDITING", "GRAPHIC DESIGN", "BOTH"];

export const EMPTY_BRIEF = Object.freeze({
  name: "",
  email: "",
  phone: "",
  requirement: "",
  description: "",
  deadline: "",
  reference: "",
  website: "",
});

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^\+?[0-9 ().-]+$/;

const validReference = (value) => {
  if (!value) return true;
  try {
    return ["http:", "https:"].includes(new URL(value).protocol);
  } catch {
    return false;
  }
};

export const validateBrief = (form) => {
  const digits = form.phone.replace(/\D/g, "");
  if (
    form.name.trim().length < 2 ||
    !EMAIL_PATTERN.test(form.email.trim()) ||
    !REQUIREMENTS.includes(form.requirement) ||
    !PHONE_PATTERN.test(form.phone.trim()) ||
    digits.length < 7 ||
    digits.length > 15
  ) {
    return "Please enter your name, a valid email and phone number, and select a service.";
  }
  if (!validReference(form.reference)) {
    return "Please enter a full http:// or https:// reference link.";
  }
  return "";
};

export const submissionErrorMessage = (status) => {
  if (status === 429) {
    return "Too many enquiries. Please wait before trying again. Your details are still here.";
  }
  if (status === 422) {
    return "Please check your details, including a full http:// or https:// reference link, and try again.";
  }
  if (status === 409) {
    return "Your enquiry has changed. Please submit it again to save the updated details.";
  }
  return "Something went wrong while submitting your enquiry. Please try again.";
};